import { useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

export const Kontak = () => {
  const fadeIn = (delay = 0) => ({
    initial: { opacity: 0, y: 15 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.5, delay, ease: "easeOut" },
    viewport: { once: true },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-40 bg-white text-slate-700">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="grid md:grid-cols-2 gap-16 items-start">
          {/* Contact Info */}
          <motion.div {...fadeIn(0.3)}>
            <motion.p
              {...fadeIn(0.2)}
              className="text-2xl sm:text-3xl md:text-5xl font-black mb-10"
            >
              Contact Us
            </motion.p>

            <p className="text-lg text-slate-700 leading-relaxed mb-10">
              Thank you for visiting Mountain Marathon Festival! If you have any
              questions, feedback, or would like to collaborate with us, please
              feel free to reach out using the contact details below:
            </p>

            <div className="space-y-8">
              {/* Instagram moved to right column */}
            </div>
          </motion.div>

          {/* Empty space (form removed) */}
          <motion.div {...fadeIn(0.2)} className="flex flex-col justify-center">
            <div className="flex items-start">
              <FontAwesomeIcon
                icon={faInstagram}
                className="w-5 h-5 text-slate-700 mt-1 mr-4"
              />
              <div>
                <p className="font-semibold text-slate-700">Instagram</p>
                <a
                  href="https://www.instagram.com/mountainmarathonfestival/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg text-slate-700 hover:underline"
                >
                  Mountain Marathon Festival
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Kontak;
